import { useState } from 'react';
import type { ApolloError, ServerError } from '@apollo/client';
import useRouter from '../router/useRouter';
import useLogout from '../user/useLogout';

const useApolloError = () => {
  const { reload } = useRouter();
  const logout = useLogout();
  const [loggingOut, setLoggingOut] = useState(false);

  const handleApolloError = (error: ApolloError) => {
    const networkError = error.networkError as ServerError;
    if (networkError?.statusCode === 401) {
      if (!loggingOut) {
        console.error('Unauthorized request. Logging out');
        setLoggingOut(true);
        logout();
        reload();
      }
    }
  };

  return { handleApolloError };
};

export default useApolloError;
